var map = {
	"./arcos/logo-horizontal.png": 7418,
	"./iprovinay/logo-horizontal.png": 5982,
	"./juarez/logo-horizontal.png": 4840,
	"./migob/logo-horizontal.png": 1240,
	"./nayarit/logo-horizontal.png": 3057,
	"./oaxaca/logo-horizontal.png": 9647,
	"./repuve/logo-horizontal.png": 7952,
	"./tlajomulco/logo-horizontal.png": 1974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4182;